import React from 'react';
import { motion } from 'framer-motion';
import * as style from './style.module.scss';

const PlayerButton = ({ isPlayerActive, togglePlayerActive }) => {
  const pathVariants = {
    active: {
      display: 'initial',
    },
    inactive: {
      display: 'none',
    },
  };

  return (
    <motion.button
      className={style.playerbutton}
      whileHover={{ scale: 1.04 }}
      initial={false}
      whileTap={{ scale: 0.92 }}
      onClick={() => togglePlayerActive()}
      title={
        !isPlayerActive
          ? process.env.GATSBY_SITE_LANG === 'en'
            ? 'Listen to the song!'
            : 'Lyssna på låten!'
          : ``
      }
    >
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.path
          variants={pathVariants}
          animate={isPlayerActive ? 'active' : 'inactive'}
          initial="inactive"
          d="M3.04825 34.8681L34.8681 3.04827M34.5914 34.8681L2.77156 3.04827"
          stroke="black"
          strokeWidth="5px"
        />
        <motion.path
          variants={pathVariants}
          initial="active"
          animate={isPlayerActive ? 'inactive' : 'active'}
          d="M7 2 L7 36 L38 19 Z"
          fill="black"
        />
      </svg>
    </motion.button>
  );
};

export default PlayerButton;
